import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { UntypedFormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { Tag } from "../weave-tags/weave-tags.component";

@Component({
    selector: 'app-autocomplete-search',
    templateUrl: './autocomplete-search.component.html',
    styleUrls: ['./autocomplete-search.component.scss'],
    standalone: false
})
export class AutocompleteSearchComponent implements OnInit, OnDestroy {
  @Input() label: string = "Select";
  @Input() placeholder: string = "Search...";
  @Input() disabledFlag: boolean = false;
  @Input() items: any[] = [];
  @Input() itemsSource = new BehaviorSubject<Tag[]>([]);
  @Input() allItems: any[] = [];
  @Output() selectedItems: EventEmitter<any[]> = new EventEmitter<any[]>();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  itemsSearchCtrl = new UntypedFormControl();
  filteredItems: Observable<any[]>;

  showingText: string = "";
  editMode: boolean = false;

  subscribers: Subscription[] = [];

  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;

  constructor() {
    this.filteredItems = this.itemsSearchCtrl.valueChanges.pipe(
      startWith(null),
      map((tagName: string | null) => (tagName ? this._filter(tagName) : this.allItems.slice())),
    ); }

  ngOnInit() {
    //todo mark as selected and non-pickable the existing tags
   // this.allItems = this.allItems.filter(ar => !this.items.find(rm => (ar.requestKey === rm.requestKey) ));
    this.subscribers.push(
      this.itemsSource.subscribe(data => {
        this.items = data;
        this.updateValue();
      })
    );
  }

  clearItems() {
    this.allItems.forEach(item => {
      item.selected = false;
    });
    this.items = [];
    this.updateValue();
    this.selectItems();
  }

  removeItem(tag) {
    if(tag.requestKey != "") {
      this.items = this.items.filter( item => {
        return item.requestKey != tag.requestKey;
      } );
      let index = this.allItems.findIndex(existingTag => {
        return tag.requestKey == existingTag.requestKey;
      });
      if(index >= 0) {
        this.allItems[index].selected = false;
        this.updateValue();
      }
    } else {
      console.log("Tried to remove a non existing tag");
    }
    this.selectItems();
  }

  selectedItem(event: MatAutocompleteSelectedEvent): void { //add existing item, once per item
    if(this.items.filter(item => {
      return item.requestKey == event.option.value;
    }).length == 0) {
      let index = this.allItems.findIndex(existingTag => {
        return event.option.value == existingTag.requestKey;
      });
      if(index >= 0) {
        this.allItems[index].selected = true;
        this.items.push( this.allItems[index] );
        this.updateValue();
      }
      this.selectItems();
    }
    this.editMode = !this.editMode;
    this.itemsSearchCtrl.setValue( null );
  }

  selectItems() {
    this.selectedItems.emit(this.items);
  }

  updateValue() {
    this.showingText = "";
    this.items.forEach(item => {
      this.showingText += ", " + item.name;
    });
    let end = "";
    if(this.showingText.length > 49) {
      end = "...";
    }
    this.showingText = this.showingText.substr(1, 49) + end;
  }

  ngOnDestroy() {
    for (let subscriber of this.subscribers) {
      subscriber.unsubscribe();
    }
  }


  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.allItems.filter(tag => { return tag.name.toLowerCase().includes(filterValue) });
  }
}
